export const infoKeys = {
  campaignName: "campaignName",
  mediaType: "mediaType",
  budget: "budget",
  durationType: "durationType",
  pacingType: "pacingType",
  startDate: "startDate",
  endDate: "endDate",
  biddingStrategy: "biddingStrategy",
  frequencyCapping: "frequencyCapping",
  bidCap: "bidCap",
  device: "device",
  language: "language",
  location: "location",
  audience: "audience",
  flight: "flight",
  brandName: "brandName",
  goal: "goal",
  goalValue: "goalValue",
  businessType: "businessType",
  brandUrl: "brandUrl",
  businessCategory: "businessCategory",
  businessSubCategory: "businessSubCategory",
  strategyName: "strategyName",
  gender: "gender",
  age: "age",
  onscreenPosition: "onscreenPosition",
  sites: "sites",
  selectAccount: "selectAccount",
  selectPage: "selectPage",
  keyword: "keyword",
  selectPlatform: "selectPlatform",
  title: "title",
  headline: "headline",
  description: "description",
  landingUrl: "landingUrl",
  clickUrl: "clickUrl",
  tags: "tags",
  status: "status",
  planName: "planName",
  planDisplayName: "planDisplayName",
  planType: "planType",
  amount: "amount",
  tenantSupported: "tenantSupported",
  offer: "offer",
  offerValue: "offerValue",
  countrySupported: "countrySupported",
  outage: "outage",
  currencySupported: "currencySupported",
  spendLimit: "spendLimit",
  spendLimitValue: "spendLimitValue",
  autoRenew: "autoRenew",
  duration: "duration",
  durationLimitValue: "durationLimitValue",
  renewPlan: "renewPlan",
  displaySupported: "displaySupported",
  status: "status",
  io:"io",
  ioBudget:"ioBudget"
};
